import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../app/store";
import { removeToast, showToast } from "../app/slice/toastsSlice";

interface toastItem {
    type: string,
    title: string,
    message: string
}
interface classObject {
    [key: string]: string;
}

function Toasts(data: any) {
    const dispatch = useDispatch<AppDispatch>();
    let toast = {
        type: '',
        title: '',
        message: ''
    }

    // const classMap: classObject = {
    const classMap = {
        success: 'WithdrawalTostBorder',
        error: 'failedTostBorder',
        warning: 'pandingTostBorder',
        info: 'infoTostBorder',
    };

    useEffect(() => {
        //setToastsData(data);
        if (data?.type) {
            setTimeout(() => {
                dispatch(removeToast())
            }, 5000);
        }
        // eslint-disable-next-line
    }, [data]);

  
    const toastClass = classMap[data?.type as keyof typeof classMap];
    // const toastClass = classMap[data?.type] || null;
    //console.log(toastClass)
    return (
        <section className="myTosat">
            {/* <button type="button" className="btn btn-primary" id="liveToastBtn">Show live toast</button> */}
            {data?.type !== '' &&
                <div className="position-fixed top-0 right-0 p-0" style={{ zIndex: 999999,right:0 }}>
                    <div id="liveToast" className="toast show" role="alert" aria-live="assertive" aria-atomic="true" >
                        {/* <div className={`toast-body ${data?.type === 'error' ? 'failedTostBorder' : (data?.type === 'success' ? 'WithdrawalTostBorder' : (data?.type === 'warning' ? 'pandingTostBorder' : 'infoTostBorder'))}`}> */}
                        <div className={`toast-body ${toastClass}`}>
                            <div className="d-flex align-items-center">
                                <div style={{ width: '20%' }}>
                                    {data?.type === 'error' ?
                                        <div className="tostIcon failedTost">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 36 36" fill="none">
                                                <path d="M18.2561 32.2284C10.2012 32.2284 3.67188 25.699 3.67188 17.6442C3.67188 9.5893 10.2012 3.05994 18.2561 3.05994C26.311 3.05994 32.8403 9.5893 32.8403 17.6442C32.8403 25.699 26.311 32.2284 18.2561 32.2284ZM18.2561 29.3116C21.3505 29.3116 24.3181 28.0823 26.5062 25.8943C28.6943 23.7062 29.9235 20.7386 29.9235 17.6442C29.9235 14.5498 28.6943 11.5821 26.5062 9.39408C24.3181 7.20602 21.3505 5.97678 18.2561 5.97678C15.1617 5.97678 12.1941 7.20602 10.006 9.39408C7.81796 11.5821 6.58872 14.5498 6.58872 17.6442C6.58872 20.7386 7.81796 23.7062 10.006 25.8943C12.1941 28.0823 15.1617 29.3116 18.2561 29.3116ZM18.2561 15.582L22.3805 11.4561L24.4442 13.5198L20.3183 17.6442L24.4442 21.7686L22.3805 23.8323L18.2561 19.7064L14.1317 23.8323L12.068 21.7686L16.1939 17.6442L12.068 13.5198L14.1317 11.4561L18.2561 15.582Z" fill="white" />
                                            </svg>
                                        </div>

                                        :
                                        data?.type === 'success' ?
                                            <div className="tostIcon WithdrawalTost">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                                    <path d="M18.2561 33.042C10.2012 33.042 3.67188 26.5126 3.67188 18.4578C3.67188 10.4029 10.2012 3.87354 18.2561 3.87354C26.311 3.87354 32.8403 10.4029 32.8403 18.4578C32.8403 26.5126 26.311 33.042 18.2561 33.042ZM18.2561 30.1252C21.3505 30.1252 24.3181 28.8959 26.5062 26.7079C28.6943 24.5198 29.9235 21.5522 29.9235 18.4578C29.9235 15.3634 28.6943 12.3957 26.5062 10.2077C24.3181 8.01962 21.3505 6.79038 18.2561 6.79038C15.1617 6.79038 12.1941 8.01962 10.006 10.2077C7.81796 12.3957 6.58872 15.3634 6.58872 18.4578C6.58872 21.5522 7.81796 24.5198 10.006 26.7079C12.1941 28.8959 15.1617 30.1252 18.2561 30.1252ZM16.8021 24.2915L10.614 18.1034L12.6762 16.0412L16.8021 20.167L25.0509 11.9167L27.1146 13.979L16.8021 24.2915Z" fill="white" />
                                                </svg>
                                            </div>
                                            :
                                            data?.type === 'warning' ?
                                                <div className="tostIcon pandingTost">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                                        <path d="M18.2561 32.4147C10.2012 32.4147 3.67188 25.8853 3.67188 17.8305C3.67188 9.77558 10.2012 3.24622 18.2561 3.24622C26.311 3.24622 32.8403 9.77558 32.8403 17.8305C32.8403 25.8853 26.311 32.4147 18.2561 32.4147ZM18.2561 29.4978C21.3505 29.4978 24.3181 28.2686 26.5062 26.0805C28.6943 23.8925 29.9235 20.9248 29.9235 17.8305C29.9235 14.7361 28.6943 11.7684 26.5062 9.58036C24.3181 7.3923 21.3505 6.16306 18.2561 6.16306C15.1617 6.16306 12.1941 7.3923 10.006 9.58036C7.81796 11.7684 6.58872 14.7361 6.58872 17.8305C6.58872 20.9248 7.81796 23.8925 10.006 26.0805C12.1941 28.2686 15.1617 29.4978 18.2561 29.4978ZM16.7977 22.2057H19.7145V25.1226H16.7977V22.2057ZM16.7977 10.5383H19.7145V19.2889H16.7977V10.5383Z" fill="white" />
                                                    </svg>
                                                </div>
                                                :
                                                <div className="tostIcon infoTost">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                                        <path d="M18.2561 32.4147C10.2012 32.4147 3.67188 25.8853 3.67188 17.8305C3.67188 9.77558 10.2012 3.24622 18.2561 3.24622C26.311 3.24622 32.8403 9.77558 32.8403 17.8305C32.8403 25.8853 26.311 32.4147 18.2561 32.4147ZM18.2561 29.4978C21.3505 29.4978 24.3181 28.2686 26.5062 26.0805C28.6943 23.8925 29.9235 20.9248 29.9235 17.8305C29.9235 14.7361 28.6943 11.7684 26.5062 9.58036C24.3181 7.3923 21.3505 6.16306 18.2561 6.16306C15.1617 6.16306 12.1941 7.3923 10.006 9.58036C7.81796 11.7684 6.58872 14.7361 6.58872 17.8305C6.58872 20.9248 7.81796 23.8925 10.006 26.0805C12.1941 28.2686 15.1617 29.4978 18.2561 29.4978ZM16.7977 22.2057H19.7145V25.1226H16.7977V22.2057ZM16.7977 10.5383H19.7145V19.2889H16.7977V10.5383Z" fill="white" />
                                                    </svg>
                                                </div>
                                    }
                                </div>
                                <span>
                                    {data?.title && <h2>{data?.title}</h2>}
                                    {data?.message && <p>{data?.message}</p>}
                                </span>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" onClick={() => dispatch(showToast(toast))}></button>
                        </div>
                    </div>
                </div>
            }
        </section >
    )
}
export default Toasts;